// main.js
import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
// import './registerServiceWorker'

const app = createApp(App)
const head = createHead()

app
  .use(router)
  .use(head)       // ← on y ajoute le plugin @vueuse/head
  .mount('#app')

app.config.errorHandler = (err) => {
  console.log('VUE ERROR', err)
}
